import React from 'react';
import type { Insight } from '@jwp/ott-common/types/insights';

import styles from './InsightCard.module.scss';

interface InsightCardProps {
  insight: Insight;
  onClick: (insight: Insight) => void;
}

export const InsightCard: React.FC<InsightCardProps> = ({ insight, onClick }) => {
  const handleClick = (): void => {
    onClick(insight);
  };

  const handleKeyDown = (e: React.KeyboardEvent): void => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleClick();
    }
  };

  return (
    <div>
      {insight.image && <img src={insight.image} alt={insight.title} className={styles.insightsImage} />}
      <section className={styles.featureCard} onClick={handleClick} role="button" tabIndex={0} onKeyDown={handleKeyDown}>
        <h2 className={styles.featureTitle}>{insight.title}</h2>
        <p className={styles.featureDescription}>{insight.description}</p>
        <div className={styles.cupMeta}>{insight.meta}</div>
      </section>
    </div>
  );
};
